import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { useGetCommonEventAuthAttributes, useGetSystemEventAttributes } from 'src/services';

export const useSidebarEvents = () => {
  const getCommonAuthAttributes = useGetCommonEventAuthAttributes();
  const getSystemEventAttributes = useGetSystemEventAttributes();

  const trackNavigationItemClicked = useCallback(
    (label) => {
      events.trackEvent(events.SYSTEM.navigationItemClicked, {
        ...getCommonAuthAttributes(),
        ...getSystemEventAttributes(),
        ...events.getCdNamesValues({ label }),
      });
    },
    [getCommonAuthAttributes, getSystemEventAttributes]
  );

  return { trackNavigationItemClicked };
};
